'use client'

import PlausibleProvider from 'next-plausible'
import { ReactNode } from 'react'
import type { DetailedHTMLProps, ScriptHTMLAttributes } from 'react'

// 你的 first-party 前缀（和 Worker 的 PREFIX 保持一致）
const PLAUSIBLE_PREFIX = '/r7k3'

// 是否自建 plausible（你是自建，保留 true）
const PLAUSIBLE_SELF_HOSTED = true

// 本地是否要上报（建议开发时 false，除非你确实想看 localhost 数据）
const PLAUSIBLE_TRACK_LOCALHOST = false

type Props = {
  children: ReactNode
}

type PlausibleProxyMode = 'path' | 'subdomain'

type PlausibleScriptProps = DetailedHTMLProps<
  ScriptHTMLAttributes<HTMLScriptElement>,
  HTMLScriptElement
> & {
  'data-api': string
}

// const PLAUSIBLE_SITE_DOMAIN = resolveSiteDomain()
const PLAUSIBLE_SITE_DOMAIN = 'snapbracket.com'
// subdomain | path
const PLAUSIBLE_PROXY_MODE = 'path'

type PlausibleProxyProviderProps = Props & {
  mode: PlausibleProxyMode
  siteDomain: string
}

function PlausibleProxyProvider({
  children,
  mode,
  siteDomain,
}: PlausibleProxyProviderProps) {
  const proxyOrigin =
    mode === 'path' ? `https://${siteDomain}` : `https://p.${siteDomain}`
  const scriptProps: PlausibleScriptProps = {
    src: `${proxyOrigin}${PLAUSIBLE_PREFIX}/js/script.js`,
    'data-api': `${proxyOrigin}${PLAUSIBLE_PREFIX}/e`,
  }

  return (
    <PlausibleProvider
      domain={siteDomain}
      selfHosted={PLAUSIBLE_SELF_HOSTED}
      trackLocalhost={PLAUSIBLE_TRACK_LOCALHOST}
      // 可选：你如果要 outbound-links / file-downloads，用 next-plausible 的 prop 开启
      // trackOutboundLinks
      // trackFileDownloads
      // ✅ 关键：把脚本 src 和上报 data-api 都改成走 /r7k3
      scriptProps={scriptProps}
    >
      {children}
    </PlausibleProvider>
  )
}

export default function PlausibleAnalyticsProvider({ children }: Props) {
  return (
    <PlausibleProxyProvider
      mode={PLAUSIBLE_PROXY_MODE}
      siteDomain={PLAUSIBLE_SITE_DOMAIN}
    >
      {children}
    </PlausibleProxyProvider>
  )
}
